//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicService from '@/service/public'
import Service from '@/service'
import { App_User } from '@/data/user_info'
import SubscribeTip from '../_components/_subscribe_tip'
export default {
    data() {
        return {
            first_favourite: true,
        }
    },
    methods: {
        goCall () {
            this.$showCallModal(this.getPhoneCall, '楼盘动态——电话拨打')
        },
        getPhoneCall () {
            PublicService.getPhonePosition({
                building_id: this.building_id
            }).then(({ phone }) => {
                this.$wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        },
        toggleFavourite (log_name) {
            App_User.get().then((data) => {
                if (data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    this.first_favourite = false
                    const { follow_info, favourite } = this
                    if (!follow_info) {
                        return
                    }
                    if (favourite) {
                        Service.delMyFavourite(follow_info.id)
                    } else {
                        log_name && this.$sendCtmEvtLog(log_name)
                        Service.addMyFavourite({
                            followable_type: follow_info.followable_type,
                            followable_id: follow_info.followable_id,
                        })
                    }
                    this.$emit('getData')
                }
            })

        },
    },
    components:{
        SubscribeTip
    },
    props: {
        building_id: [String, Number],
        is_building_consultant: Boolean,
        favourite: {
            type: Boolean
        },
        follow_info: {
            type: Object
        },
        is_consultant: {
            type: Boolean
        },
        add_group_url: String
    }
}
